import RewindJob from '../../../../../types/api/rewind-job'
import RewindJobExecutor from '../../../../../types/api/rewind-job-executor'
import { RewindJobStatuses } from '../../../../../types/api/rewind-job'

export function getActiveExecutor(rewindJob?: RewindJob): RewindJobExecutor | undefined {
    return rewindJob?.rewind_job_executors?.find(executor => !executor.end)
}

export function hasActiveExecutor(rewindJob?: RewindJob): boolean {
    return !!getActiveExecutor(rewindJob)
}

export function isRewindJobPaused(rewindJob?: RewindJob): boolean {
    return rewindJob?.jobStatus === RewindJobStatuses.Rewinding && !hasActiveExecutor(rewindJob)
}

export function isRewindJobActive(rewindJob?: RewindJob): boolean {
    return rewindJob?.jobStatus === RewindJobStatuses.Rewinding && hasActiveExecutor(rewindJob)
}

export function isRewindJobInProgress(rewindJob?: RewindJob): boolean {
    return rewindJob?.jobStatus === RewindJobStatuses.Rewinding
}

export function getCurrentUserActiveExecutor(
    rewindJob?: RewindJob,
    userDocumentId?: string
): RewindJobExecutor | undefined {
    if (!userDocumentId) return undefined

    return rewindJob?.rewind_job_executors?.find(
        executor => executor.user.documentId === userDocumentId && !executor.end
    )
}

export function isCurrentUserActiveExecutor(rewindJob?: RewindJob, userDocumentId?: string): boolean {
    return !!getCurrentUserActiveExecutor(rewindJob, userDocumentId)
}
